import Alpine from 'alpinejs';
import IMask from 'imask';

Alpine.store('formValidColl', {
    contactForm: {
        name: '',
        email: '',
        phone: '',
    },

    contactErrors: {
        name: null,
        email: null,
        phone: null,
    },

    validateContactForm() {
        const emailPattern = /^[^\s@()]+@[^\s@]+\.[^\s@]+$/;
        const namePattern = /^[A-Za-zА-Яа-яЁёЇїІіЄєҐґ'’\- ]+$/;
        const phonePattern = /^\+38\(\d{3}\)\d{3}-\d{2}-\d{2}$/;

        this.contactErrors = {
            name: !this.contactForm.name
                ? 'Заповніть це поле'
                : this.contactForm.name.length < 2
                    ? 'Ім’я повинно містити хоча б 2 символи'
                    : !namePattern.test(this.contactForm.name)
                        ? 'Ім’я повинно містити тільки літери'
                        : null,


            email: !this.contactForm.email
                ? 'Заповніть це поле'
                : !emailPattern.test(this.contactForm.email)
                    ? 'Введіть коректний email'
                    : null,

            phone: !this.contactForm.phone
                ? 'Заповніть це поле'
                : !phonePattern.test(this.contactForm.phone)
                    ? 'Введіть коректний номер телефону'
                    : null,


        };

        if (!Object.values(this.contactErrors).some(error => error)) {
            this.sendFormContact();
        }
    },

    sendFormContact() {
        const formData = new FormData();
        formData.append('name', this.contactForm.name);
        formData.append('email', this.contactForm.email);
        formData.append('phone', this.contactForm.phone);
        formData.append('job_position_id', document.getElementById('job_position_idCol')?.value || '');


        fetch('/api/v1/store/call_requests', {
            method: 'POST',
            body: formData,
        })
            .then(async response => {
                if (!response.ok) throw new Error('Network error');
                this.clearFormContact();
                Toastify({
                    text: "Успішно",
                    duration: 2000,
                    destination: "https://github.com/apvarun/toastify-js",
                    newWindow: true,
                    close: true,
                    gravity: "top",
                    position: "right",
                    style: {
                        background: "#28a745",
                        color: "#fff"
                    }
                }).showToast();
                window.togglePopup();
            })
            .catch(error => console.error(error));
    },

    clearFormContact() {
        this.contactForm = {
            name: '',
            email: '',
            phone: '',
        };
        this.contactErrors = {
            name: null,
            email: null,
            phone: null,
        };

        const fields = ['name', 'email', 'phone', 'message'];
        fields.forEach(field => {
            const input = document.querySelector(`input[name="${field}"]`);
            if (input) input.value = '';
        });


    }
});


